import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomConsensusModalComponent } from "./custom-consensus-modal/custom-consensus-modal.component";
import { IconsModule } from "@va/core-library/icons";

import { CustomConsensusCoreComponent } from "./custom-consensus-core/custom-consensus-core.component";
import { SharedModule } from "../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FormatDatePipe, CcCompare } from "./custom-consensus.pipe";
import { CustomConsensusNodataModalComponent } from "./custom-consensus-nodata-modal/custom-consensus-nodata-modal.component";
import { NzTabsModule } from "ng-zorro-antd/tabs";
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzCheckboxModule } from "ng-zorro-antd/checkbox";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzDatePickerModule } from "ng-zorro-antd/date-picker";
import { NzInputModule } from "ng-zorro-antd/input";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzRadioModule } from "ng-zorro-antd/radio";
import { NzSpinModule } from "ng-zorro-antd/spin";

@NgModule({
  declarations: [
    CustomConsensusModalComponent,
    CustomConsensusCoreComponent,
    CcCompare,
    FormatDatePipe,
    CustomConsensusNodataModalComponent,
  ],
  imports: [
    CommonModule,
    IconsModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NzTabsModule,
    NzButtonModule,
    NzCheckboxModule,
    NzToolTipModule,
    NzCheckboxModule,
    NzGridModule,
    NzDatePickerModule,
    NzInputModule,
    NzModalModule,
    NzRadioModule,
    NzSpinModule,
  ],
  exports: [
    CustomConsensusModalComponent,
    CustomConsensusCoreComponent,
    CustomConsensusNodataModalComponent,
  ],
})
export class CustomConsensusModule {}
